import { ButtonHTMLAttributes } from "react";

interface TrashListHoverButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

const TrashListHoverButton = ({ children, ...props }: TrashListHoverButtonProps) => {
  return (
    <button
      {...props}
      className="flex h-[24px] w-[24px] items-center justify-center rounded-[5px] bg-[rgba(0,0,0,0.4)] text-[16px] backdrop-blur-[2px] hover:bg-[rgba(0,0,0,0.6)]"
    >
      {children}
    </button>
  );
};

export default TrashListHoverButton;
